import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/pricing/types';

export default createUseStyles(({ spacing }: PricingAppTheme) => ({
  Back: {
    margin: '0 auto',
    padding: [spacing[6], spacing[6], 0],
    '& a': {
      fontSize: 14,
      display: 'inline-flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 3,
      },
    },
  },
}));
